import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import notifierReducer from './notifierReducer';
import usersReducer from '../views/Management/reducers/UsersReducer';
import operatorsReducer from '../views/Management/reducers/OperatorsReducer';
import settingsReducer from '../views/Management/reducers/SettingsReducer';
import dashboardInspectReducer from '../views/Dashboard/reducers/DashboardInspectReducer';
import mapReducer from '../components/Map/reducers/MapReducer';
import parameterPlanningReducer from '../views/ParameterPlanning/reducers/ParameterPlanningReducer';
import commissioningPlanReducer from '../views/Tracking/reducers/CommissioningPlanReducer';
import cpichValidationReducer from '../views/Validation/reducers/CpichValidationReducer';
import trackerReducer from '../views/Tracking/reducers/TrackerReducer';
import nbrRelationsValidationReducer from '../views/Validation/reducers/NbrRelationsValidationReducer';
import healthChecksReducer from '../views/Validation/reducers/HealthChecksReducer';
import workOrderStatusReducer from '../views/Tracking/reducers/WorkOrderStatusReducer';
import nbrRelationsOptimizationReducer from '../views/Optimization/reducers/NbrRelationsOptimizationReducer';
import faultManagementReducer from '../views/Monitoring/reducers/FaultManagementReducer';
import configurationManagementReducer from '../views/Monitoring/reducers/ConfigurationManagementReducer';
import overallSiteSummaryReducer from '../views/Monitoring/reducers/OverallSiteSummaryReducer';
import siteReportReducer from '../views/Monitoring/reducers/SiteReportReducer';
import uploadLogsReducer from '../views/Monitoring/reducers/UploadLogsReducer';
import ranshareNbrRelationsValidationReducer from '../views/Validation/reducers/RanShareNbrRelationsValidationReducer';
import anrValidationReducer from '../views/Validation/reducers/ANRValidationReducer';
import anrNbrTrackingReducer from '../views/Validation/reducers/AnrNbrTrackingReducer';
import cositeHealthCheckReducer from '../views/Validation/reducers/CositeHealthCheckReducer';

const rootReducer = combineReducers({
	session: sessionReducer,
	usersReducer,
	notifierReducer,
	operatorsReducer,
	settingsReducer,
	dashboardInspectReducer,
	mapReducer,
	parameterPlanningReducer,
	commissioningPlanReducer,
	cpichValidationReducer,
	trackerReducer,
	nbrRelationsValidationReducer,
	healthChecksReducer,
	workOrderStatusReducer,
	nbrRelationsOptimizationReducer,
	faultManagementReducer,
	configurationManagementReducer,
	overallSiteSummaryReducer,
	siteReportReducer,
	uploadLogsReducer,
	ranshareNbrRelationsValidationReducer,
	anrValidationReducer,
	anrNbrTrackingReducer,
	cositeHealthCheckReducer
});

export default rootReducer;
